// extracted by mini-css-extract-plugin
module.exports = {"summary__stats":"K_c3","summary__stats__links":"K_c4","summary__stats__links__single":"K_c5"};